export default [
  {
    path: "/comprobantes",
    name: "comprobantes",
    component: () => import(/* webpackChunkName: "comprobantes-page" */ "@/modules/comprobantes/pages/ComprobantesPage2.vue"),
  },
  {
    path: "/comprobantes/emitir",
    name: "comprobantes.nuevo",
    component: () => import(/* webpackChunkName: "comprobantes-nuevo-page" */ "@/modules/comprobantes/pages/ComprobantesNuevoPage2.vue"),
  },
];
